import { render, staticRenderFns } from "./top-products-echart.vue?vue&type=template&id=3bdaa0aa&scoped=true&"
import script from "./top-products-echart.vue?vue&type=script&lang=js&"
export * from "./top-products-echart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bdaa0aa",
  null
  
)

export default component.exports